import cn from 'classnames';
import React from 'react';
interface Props {
  size?: SpinnerSize;
  type?: SpinnerType;
  inline?: boolean;
}

type SpinnerType = 'inverse';
type SpinnerSize = 'sm' | 'md' | 'lg';
const Spinner = React.forwardRef<HTMLSpanElement, Props>((props, ref) => {
  const { size, type, inline } = props;
  const classNames = cn('spinner', {
    [`spinner-${size}`]: size,
    [`spinner-${type}`]: type,
    'spinner-inline': inline
  });

  return (
    <span ref={ref} className={classNames}>
      Loading...
    </span>
  );
});

export default Spinner;
